import useGetSet from './useGetSet';
import { useCallback } from 'react';
var useCounter = function (initialValue) {
    if (initialValue === void 0) { initialValue = 0; }
    var _a = useGetSet(initialValue), get = _a[0], set = _a[1];
    var inc = useCallback(function (delta) {
        if (delta === void 0) { delta = 1; }
        return set(get() + delta);
    }, []);
    var dec = useCallback(function (delta) {
        if (delta === void 0) { delta = 1; }
        return inc(-delta);
    }, []);
    var reset = useCallback(function (value) {
        if (value === void 0) { value = initialValue; }
        initialValue = value;
        set(value);
    }, []);
    var actions = {
        inc: inc,
        dec: dec,
        get: get,
        set: set,
        reset: reset,
    };
    return [get(), actions];
};
export default useCounter;
